module.exports = __webpack_public_path__ + "img/business15_E.3de341c6.png";